import { medicalAssistantsRouteStore } from '../domain/store';

import { listMedicalAssistants } from './index';

export default (e) => {
  medicalAssistantsRouteStore.setValue('filterValue', e.target.value);
  medicalAssistantsRouteStore.setValue('currentPage', 1);
  return listMedicalAssistants();
};
